<div class="w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0 mt-8">
    <form [formGroup]="pageForm" (ngSubmit)="bulkUpload()">
        <div class="rounded-t bg-white">
            <div class="items-center content-center py-4">
                <h3 class="text-blueGray-700 ml-4 text-lg font-bold">Bulk Upload Prayers</h3>
            </div>
        </div>
        <mat-stepper orientation="vertical" linear="false" #stepper>
            <mat-step [completed]="pageForm.get('prayerText')?.valid" class="bg-blueGray-100" label="Share Prayers">

                <!-- TODO: Options of xls upload / pasting text -->
                <!-- <div class="border-b border-gray-200 dark:border-gray-700">
                        <ul
                            class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
                            <li class="me-2">
                                <a href="#fileUpload"
                                    class="inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                                    <i class="fa fa-save mr-2 leading-relaxed"></i>File (.xls, .xlsx)
                                </a>
                            </li>
                            <li class="me-2">
                                <a href="#pasteText"
                                    class="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group">
                                    <i class="fa fa-save mr-2 leading-relaxed"></i>Paste Text
                                </a>
                            </li>
                        </ul>
                    </div> -->

                <!-- <div id="fileUpload" class="pt-4">
                        <h3 class="text-xl text-blueGray-600 uppercase font-bold">File Requirements</h3>
                        <ul class="list-disc list-inside text-sm text-primary-300 mt-4 space-y-1">
                            <li>Only .xls, .xlsx files are allowed.</li>
                            <li>For performance reasons, we limit the records
                                processed to max 100. Kindly upload Prayers in batches of less than 100 records.</li>
                            <li>Please make sure your Prayers are on the first
                                worksheet of the xls.</li>
                            <li>The file should have a Header row with below specified column:</li>
                            <ul class="indent-4 list-disc list-inside text-sm text-primary-300 space-y-1">
                                <li>Subject *</li>
                                <li>Description *</li>
                                <li>Category *</li>
                                <li>Created Date</li>
                                <li>Tags (comma separated values, max 10)</li>
                            </ul>
                        </ul>
                        <label class="block uppercase text-blueGray-600 text-md font-bold mt-4 mb-1">
                            File (.xls, .xlsx)
                        </label>
                        <input type="file" required (change)="pickFile($event)" accept=".xls,.xlsx" class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow
                        focus:outline-none focus:ring py-1.5 px-3 ease-linear transition-all duration-150" rows="4" />
                    </div> 
                    <div>
                        <button type="button" [disabled]="file == null"
                            class="bg-secondary-500 hover:bg-primary-300 active:bg-primary-500 disabled:bg-primary-100 mt-8 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                            (click)="readFile()">Process File</button>
                    </div> -->

                <div class="mt-2">
                    <label class="text-sm text-blueGray-600 uppercase font-bold">Content Requirements</label>
                    <ul class="indent-2 list-disc list-inside text-sm text-primary-300 mt-2 space-y-1">
                        <li>Every new line is considered a new Prayer request.</li>
                        <li>For performance reasons, we limit the records
                            processed to max 100. Kindly paste Prayers in batches of less than 100 records.</li>
                    </ul>
                    <label class="block uppercase text-blueGray-600 text-sm font-bold mt-4 mb-2">
                        Paste Prayer(s)
                    </label>
                    <textarea formControlName="prayerText" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 w-full min-h-[300px] bg-white rounded text-sm shadow"></textarea>
                </div>
                <div>
                    <button type="button" [disabled]="file == null"
                        class="bg-secondary-500 hover:bg-primary-300 active:bg-primary-500 disabled:bg-primary-100 mt-8 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                        (click)="readContent()">Process Content</button>
                </div>
            </mat-step>
            <mat-step [stepControl]="pageForm" label="Review Mappings">

                <div class="bg-white rounded-t mb-0 px-4 py-3 mt-4 border-0">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full px-2 max-w-full flex-grow flex-1">
                            <h3 class="font-semibold text-lg text-blueGray-700">
                                Prayers
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="bg-white shadow-lg border-0">
                    <table class="items-center w-full bg-transparent text-sm border-collapse">
                        <thead class="bg-blueGray-100">
                            <tr>
                                <th
                                    class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                    Subject
                                </th>
                                <th
                                    class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                    Description
                                </th>
                                <th
                                    class=" px-6 align-middle border-0 border-solid py-3 uppercase border-l-0 border-r-0
                          whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                    Created Date
                                </th>
                                <th
                                    class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                    Category
                                </th>
                                <th
                                    class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                    Tag(s)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of prayers">
                                <td
                                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4 text-left flex items-center">
                                    <a [routerLink]="[item.id]">
                                        <div
                                            class="flex-1 inline-flex flex-span ml-3 text-sm font-bold text-blueGray-600">
                                            <span>{{item.subject}}</span>
                                        </div>
                                    </a>
                                </td>
                                <td
                                    class="border-t-0 px-6 align-middle text-sm border-l-0 border-r-0 whitespace-nowrap p-4">
                                    <!-- {{item.modified!.toString() | luxon: 'DD-MM-YYYY hh:mm a'}} -->
                                    {{ item.modified }}
                                </td>
                                <td
                                    class="border-t-0 px-6 align-middle text-sm border-l-0 border-r-0 whitespace-nowrap">
                                    <span data-dismissible="chip"
                                        class="relative select-none center whitespace-nowrap w-auto rounded-lg {{item.status === 'active' ? 'bg-green-50 text-green-700' : item.status == 'request' ? 'bg-yellow-50 text-yellow-600' : item.status == 'closed' ? 'bg-blue-200 text-blue-500' : 'bg-primary-100 text-primary-500'}} py-1.5 px-3 text-xs font-semibold ">
                                        {{item.status}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <button type="submit"
                        class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 mt-8 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                        mat-button>
                        <div *ngIf="!loading" class="inline-block">
                            <i class="fa fa-save mr-2 leading-relaxed"></i>Create
                        </div>
                        <div *ngIf="loading" class="inline-block">
                            <app-loading-dots></app-loading-dots>
                        </div>
                    </button>
                </div>
            </mat-step>
        </mat-stepper>
    </form>
</div>